import { com } from '@eidu/web'
import React from 'react'
import { Card, Stack, Typography } from '@mui/material'
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId
import SemanticLink = com.eidu.sharedlib.entity.analytics.SemanticLink
import SemanticLinkId = com.eidu.sharedlib.entity.analytics.SemanticLinkId
import FieldType = com.eidu.sharedlib.entity.field.FieldType
import SemanticLinkItem from '../input/SemanticLinkItem'

type SemanticLinkDisplayProps = {
  entityTypeId: EntityTypeId
  entityTypes: readonly EntityType[]
  fieldType: FieldType
  semanticLinks: readonly SemanticLink[]
  onDelete?: (semanticLinkId: SemanticLinkId) => Promise<void>
}

const SemanticLinkDisplay = ({
  entityTypeId,
  entityTypes,
  fieldType,
  semanticLinks,
  onDelete,
}: SemanticLinkDisplayProps) => (
  <Stack spacing={1}>
    {semanticLinks.length > 0 ? (
      semanticLinks.map(({ path, id: linkId }) => (
        <SemanticLinkItem
          key={linkId.toString()}
          linkId={linkId}
          path={path}
          entityTypeId={entityTypeId}
          entityTypes={entityTypes}
          onDelete={onDelete}
          fieldType={fieldType}
        />
      ))
    ) : (
      <Card>
        <Stack padding={2}>
          <Typography>No links found</Typography>
        </Stack>
      </Card>
    )}
  </Stack>
)

export default SemanticLinkDisplay
